"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Size_1 = __importDefault(require("./Size"));
var Box = /** @class */ (function () {
    function Box(dataId, id, parentId, isSpecial, disableCollisionDetection, isAssistant) {
        if (id == 0) {
            throw new Error("Invalid " + id);
        }
        this.Id = id;
        this.ParentId = parentId;
        this.DataId = dataId;
        this.IsSpecial = isSpecial;
        this.IsAssistant = isAssistant;
        this.DisableCollisionDetection = disableCollisionDetection;
        this.AssistantLayoutStrategyId = null;
        this.LayoutStrategyId = null;
        this.IsCollapsed = false;
        this.Size = new Size_1.default(0, 0);
    }
    Object.defineProperty(Box.prototype, "IsDataBound", {
        get: function () {
            return !!this.DataId;
        },
        enumerable: false,
        configurable: true
    });
    Box.Special = function (id, visualParentId, disableCollisionDetection) {
        return new Box(null, id, visualParentId, true, disableCollisionDetection, false);
    };
    Box.None = -1;
    return Box;
}());
exports.default = Box;
